<template>
    <div class="d-print-none">
        <div class="navigation-bar">
            <div>
                <div class="container">
                    <div class="row">
                        <div class="col-auto col-brand">
                            <button class="menu-btn d-md-none btn btn-primary"
                                    v-on:click="menuMobileVisible = !menuMobileVisible">
                                <font-awesome-icon :icon="['fal', menuMobileVisible ? 'times' : 'bars']"/>
                            </button>
                            <router-link to="/" class="brand">foodsoft</router-link>
                        </div>
                        <div class="col">
                            <navigation-links class="menu-desktop d-md-flex"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="menuMobileVisible" class="menu-mobile-scrollable d-md-none">
            <div class="menu-mobile-container">
                <navigation-links class="menu-mobile"/>
                <a role="button" class="menu-mobile-overlay" v-on:click="menuMobileVisible = false"></a>
            </div>
        </div>
    </div>
</template>

<script>
    import NavigationLinks from "./NavigationLinks";

    export default {
        name: "NavigationBar",
        components: {NavigationLinks},
        data: () => ({
            menuMobileVisible: false
        }),
        watch: {
            menuMobileVisible(newValue) {
                this.updateMenuMobileBodyClass(newValue);
            }
        },
        beforeDestroy() {
            if (this.menuMobileVisible) {
                this.menuMobileVisible = false;
                this.updateMenuMobileBodyClass(false);
            }
        },
        methods: {
            updateMenuMobileBodyClass(menuMobileVisible) {
                if (menuMobileVisible && !document.documentElement.classList.contains("menu-mobile-visible")) {
                    const scrollTop = document.documentElement.scrollTop;
                    document.documentElement.classList.add("menu-mobile-visible");
                    document.body.scrollTop = scrollTop;
                } else if (!menuMobileVisible && document.documentElement.classList.contains("menu-mobile-visible")) {
                    const scrollTop = document.body.scrollTop;
                    document.documentElement.classList.remove("menu-mobile-visible");
                    document.documentElement.scrollTop = scrollTop;
                }
            }
        }

    }
</script>

<style>
    @media (max-width: 767.98px) {
        html.menu-mobile-visible {
            overflow: hidden;
        }

        html.menu-mobile-visible body {
            max-height: 100vh;
            overflow: auto;
        }
    }
</style>

<style lang="scss">
    .navigation-bar {
        height: 50px;

        > div {
            background: #fcd05e;
            height: 50px;
            position: fixed;
            left: 0;
            right: 0;
            z-index: 10;
        }

        .col-brand {
            display: flex;
        }

        .brand {
            line-height: 50px;
            color: #262c40;
            font-family: Poppins, sans-serif;
            font-weight: 500;
            font-size: 22px;
            text-decoration: none;
        }

        .menu-btn {
            width: 36px;
            height: 34px;
            line-height: 34px;
            padding: 0;
            align-self: center;
            margin-right: 13px;
            font-size: 18px;
        }
    }

    .menu-desktop {
        display: none;
        list-style: none;
        padding: 0;
        margin: 0;
        font-family: Poppins, sans-serif;
        font-weight: 300;

        > li {
            position: relative;

            &.spacer {
                flex-grow: 1;
            }

            > a, > .label-only {
                display: inline-block;
                line-height: 50px;
                color: #262c40;
                font-size: 14px;
                padding: 0 14px;
                text-decoration: none;
            }

            &:hover > a, &:hover > .label-only {
                background: #25262a;
                color: #fff;
            }

            &.router-link-exact-active > a {
                font-weight: 500;
            }

            .caret {
                margin-left: 1px;
            }

            ul {
                position: absolute;
                list-style: none;
                padding: 10px;
                margin: 0;
                background: #25262a;
                display: none;
                flex-direction: column;
                border-radius: 0 0 4px 4px;

                li {
                    border-radius: 18px;

                    .label-only {
                        display: inline-block;
                        line-height: 25px;
                        width: 200px;
                        padding: 0 15px;
                        color: #d9d6ce;
                        font-size: 14px;
                    }

                    a {
                        display: inline-block;
                        width: 200px;
                        line-height: 35px;
                        padding: 0 15px;
                        border-radius: 18px;
                        text-decoration: none;
                        color: #fff;
                    }

                    &:hover a {
                        background: #fcd05e;
                        color: #262c40;
                    }

                    &.divider {
                        border-top: 1px dashed #7a7f91;
                        margin: 10px 15px;
                    }
                }

                &.right {
                    right: 0;
                }
            }

            &:hover ul {
                display: flex;
            }
        }
    }

    .menu-mobile-scrollable {
        position: fixed;
        z-index: 9;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
    }

    .menu-mobile-container {
        position: absolute;
        display: flex;
        align-items: stretch;
        width: 100%;
        min-height: calc(100vh - 50px);
    }

    .menu-mobile-overlay {
        display: block;
        position: relative;
        flex-grow: 1;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1;
        background: rgba(0, 0, 0, .4);
        cursor: pointer;
    }

    .menu-mobile {
        position: relative;
        top: 0;
        z-index: 2;

        width: 210px;
        min-height: calc(100vh - 50px);
        background: #25262a;
        padding: 10px;
        margin: 0;
        font-family: Poppins, sans-serif;
        font-weight: 300;
        list-style: none;

        > li {
            &.spacer {
                display: none;
            }

            > .label-only {
                display: inline-block;
                line-height: 25px;
                width: 200px;
                margin-top: 10px;
                padding: 0 15px;
                color: #d9d6ce;
                font-size: 11px;
            }

            > a {
                color: #fff;
                text-decoration: none;

                display: block;
                line-height: 35px;
                padding: 0 15px;
                border-radius: 18px;
            }

            &:hover > a {
                background: #fcd05e;
                color: #262c40;
            }

            &.divider {
                border-top: 1px dashed #7a7f91;
                margin: 10px 15px;
            }

            > ul {
                background: rgba(255, 255, 255, 0.05);
                margin: 0 -10px 10px;
                padding: 10px;
                list-style: none;

                > li {
                    > a {
                        color: #fff;
                        text-decoration: none;

                        display: block;
                        line-height: 35px;
                        padding: 0 15px;
                        border-radius: 18px;
                    }

                    > .label-only {
                        display: inline-block;
                        line-height: 25px;
                        width: 200px;
                        padding: 0 15px;
                        color: #d9d6ce;
                        font-size: 14px;
                    }

                    &:hover > a {
                        background: #fcd05e;
                        color: #262c40;
                    }

                    &.divider {
                        border-top: 1px dashed #7a7f91;
                        margin: 10px 15px;
                    }
                }
            }
        }
    }
</style>
